import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicInvitation } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getInvitation = async (id: string): Promise<PublicInvitation> => {
  const response = await axiosClient.get(`invitations/${id}`);
  return response.data;
};

export function useGetInvitation(
  { id }: { id: string },
  queryOptions?: Partial<UseQueryOptions<PublicInvitation, HttpError>>,
) {
  return useQuery({
    queryKey: ["invitation", id],
    queryFn: () => getInvitation(id),
    ...queryOptions,
  });
}
